import { Grid } from '@mui/material';
import { IAsset } from '../../../../../../Interfaces/Asset/IAsset';
import { IConfig } from '../../../../../../Interfaces/IConfig';
import { IInventoryOption } from '../../../../../../Interfaces/IInventoryOption';
import { ILegalClient } from '../../../../../../Interfaces/ILegalClient';
import { IPropertyType } from '../../../../../../Interfaces/IPropertyType';
import { IRealEstate } from '../../../../../../Interfaces/IRealEstate';
import { IRealEstateHasInventoryOption } from '../../../../../../Interfaces/IRealEstateHasInventoryOption';
import { IRealEstateHasPropertyType } from '../../../../../../Interfaces/IRealEstateHasPropertyType';
import { IRealEstateUseType } from '../../../../../../Interfaces/IRealEstateUseType';
import { TestamentRealEstate } from '../TestamentRealEstate';

type RealEstateAssetsSectionProps = {
  configObject: IConfig;
  handleBack: () => void;
  handleNext: () => void;
  realEstateArray: IRealEstate[];
  setRealEstateArray: React.Dispatch<React.SetStateAction<IRealEstate[]>>;
  realEstateHasPropertyTypeArray: IRealEstateHasPropertyType[];
  setRealEstateHasPropertyTypeArray: React.Dispatch<
    React.SetStateAction<IRealEstateHasPropertyType[]>
  >;
  propertyTypeArray: IPropertyType[];
  realEstateHasInventroyOptionArray: IRealEstateHasInventoryOption[];
  setRealEstateHasInventroyOptionArray: React.Dispatch<
    React.SetStateAction<IRealEstateHasInventoryOption[]>
  >;
  inventoryOptionArray: IInventoryOption[];
  realEstateUseTypeArray: IRealEstateUseType[];
  legalClientArray: ILegalClient[];
  setLegalClientArray: React.Dispatch<React.SetStateAction<ILegalClient[]>>;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  assets: IAsset[];
  setAssets: React.Dispatch<React.SetStateAction<IAsset[]>>;
};

export function RealEstateAssetsSection({
  configObject,
  handleBack,
  handleNext,
  realEstateArray,
  setRealEstateArray,
  realEstateHasPropertyTypeArray,
  setRealEstateHasPropertyTypeArray,
  propertyTypeArray,
  realEstateHasInventroyOptionArray,
  setRealEstateHasInventroyOptionArray,
  inventoryOptionArray,
  realEstateUseTypeArray,
  legalClientArray,
  setLegalClientArray,
}: RealEstateAssetsSectionProps) {
  return (
    <Grid item xs={12}>
      <TestamentRealEstate
        configObject={configObject}
        handleBack={handleBack}
        handleNext={handleNext}
        realEstateArray={realEstateArray}
        setRealEstateArray={setRealEstateArray}
        realEstateHasPropertyTypeArray={realEstateHasPropertyTypeArray}
        setRealEstateHasPropertyTypeArray={setRealEstateHasPropertyTypeArray}
        propertyTypeArray={propertyTypeArray}
        realEstateHasInventroyOptionArray={realEstateHasInventroyOptionArray}
        setRealEstateHasInventroyOptionArray={
          setRealEstateHasInventroyOptionArray
        }
        inventoryOptionArray={inventoryOptionArray}
        realEstateUseTypeArray={realEstateUseTypeArray}
        legalClientArray={legalClientArray}
        setLegalClientArray={
          setLegalClientArray as React.Dispatch<
            React.SetStateAction<ILegalClient[]>
          >
        }
      />
    </Grid>
  );
}
